module.exports = __webpack_public_path__ + "static/media/ANKITA-PORWAL.5f4259c8.png";